const t = "_wrapper_xj4jm_1", e = "_title_xj4jm_7", p = "_innerWrapper_xj4jm_12", r = "_topItemsWrapper_xj4jm_15", _ = "_items_xj4jm_20", n = "_item_xj4jm_20", s = "_link_xj4jm_30", m = {
  wrapper: t,
  title: e,
  innerWrapper: p,
  topItemsWrapper: r,
  items: _,
  item: n,
  link: s
};
export {
  m as default,
  p as innerWrapper,
  n as item,
  _ as items,
  s as link,
  e as title,
  r as topItemsWrapper,
  t as wrapper
};
